import { useState, useEffect } from "react";
import { Type } from "lucide-react";

const KEY = "ata_font_pct";
const MIN = 85, MAX = 130, STEP = 7.5;

export default function AccessibilityWidget() {
  const [pct, setPct] = useState(() => Number(localStorage.getItem(KEY)) || 100);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.documentElement.style.fontSize = `${(pct / 100) * 16}px`;
    localStorage.setItem(KEY, String(pct));
  }, [pct]);

  return (
    <div data-testid="accessibility-widget" className="fixed left-0 top-1/2 -translate-y-1/2 z-40 flex items-center">
      <div className={`flex flex-col gap-1 bg-white border border-stone-200 border-l-0 rounded-r-xl shadow-lg p-1.5 transition-all ${open ? "" : "-translate-x-[calc(100%-2.5rem)]"}`}>
        <button data-testid="accessibility-toggle" onClick={() => setOpen(!open)} aria-label="Erişilebilirlik" className="w-9 h-9 flex items-center justify-center text-forest hover:bg-cream-dark rounded-lg transition-colors">
          <Type className="w-[18px] h-[18px]" />
        </button>
        <button
          data-testid="font-decrease"
          onClick={() => setPct((p) => Math.max(MIN, p - STEP))}
          disabled={pct <= MIN}
          aria-label="Yazı küçült"
          className="w-9 h-9 text-xs font-bold text-stone-700 hover:bg-cream-dark disabled:opacity-30 rounded-lg transition-colors"
        >A−</button>
        <span data-testid="font-size-value" className="text-[9px] text-center text-stone-400 font-semibold">{Math.round(pct)}%</span>
        <button
          data-testid="font-increase"
          onClick={() => setPct((p) => Math.min(MAX, p + STEP))}
          disabled={pct >= MAX}
          aria-label="Yazı büyüt"
          className="w-9 h-9 text-xs font-bold text-stone-700 hover:bg-cream-dark disabled:opacity-30 rounded-lg transition-colors"
        >A+</button>
      </div>
    </div>
  );
}
